import React from 'react'
import './FAQ.scss'
import Text from "../i18n/Text";
import PropTypes from "prop-types";
import FAQCard from "./FAQCard";
import Accordion from 'react-bootstrap/Accordion';


export default function FAQ({faq}) {
    if (!faq || faq.length === 0) {
        return null
    }

    let questions = sortList(faq.filter(item => item.endsWith(".q")))
    let answers = sortList(faq.filter(item => item.endsWith(".a")))

    return (
        <section>
            <h2 className="h4 my-5 text-center headless" data-test-id="fe9d3993-6c63"><Text k='common.faq'/></h2>
            <span id="faq" data-test-id="ab7d3921-2263"/>
            <Accordion>
                {questions.map((f, idx) => <FAQCard header={f} body={answers[idx]} cardId={idx} key={idx}/>)}
            </Accordion>
        </section>
    )
}

FAQ.propTypes = {
    faq: PropTypes.arrayOf(PropTypes.string)
}

function sortList(list) {
    return list.sort((a, b) => {
        let aIdx = fetchIndex(a)
        let bInx=fetchIndex(b)
        if (aIdx > bInx) {
            return 1
        }
        if (aIdx < bInx) {
            return -1
        }
        return 0
    })
}

function fetchIndex(text){
    let idx=text.match(/faq\.(\d+)\.[a,q]$/)
    if(idx){
        return Number.parseInt(idx[1])
    }
    return -1
}
